import { authorizedFetch } from '../utils';

let featureFlags = {};

export const getFeatureFlags = () => {
  return authorizedFetch('/api/featureflag')
    .then(response => {
      featureFlags = response || {};
    })
    .catch(e => {
      console.log('Failed to load feature flags', e);
      featureFlags = {};
    });
};

export const isFeatureEnabled = flagName => {
  return featureFlags[flagName] === true;
};
